export const DEFAULT = "REDUXSAUCE.DEFAULT";
